import { type SeperatorStoryblok } from '#types/component-types-sb'

const Seperator = ({ blok }: SeperatorStoryblok) => {
	return <div className={`h-[1px] w-full bg-beige-70`} />
}
export default Seperator
